import { render, staticRenderFns } from "./KaijuPayoutsList.vue?vue&type=template&id=e5a1e5b0&"
import script from "./KaijuPayoutsList.vue?vue&type=script&lang=ts&"
export * from "./KaijuPayoutsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports